import { z } from "zod";

/**
 * Finalization state of a Cede Arena competition epoch. The arena UI polls this
 * after a competition ends: while `finalizedAt` is null it shows a "Finalizing
 * results…" loader (positions are being settled + the reward credited); once the
 * finalize flow stamps it, the UI reveals the final settled leaderboard.
 */
export const ArenaCompetitionFinalizationSchema = z.object({
  campaignName: z.string(),
  epochId: z.number().int(),
  /** Null while live or mid-finalization; set when settle + reward have completed. */
  finalizedAt: z.coerce.date().nullable(),
});

export type ArenaCompetitionFinalizationDto = z.infer<typeof ArenaCompetitionFinalizationSchema>;
